import type { DummyFoods } from './dummyFoods'

export const jerky: DummyFoods = {
  Jerky: {
    Beef: ['Beef jerky'],
    Turkey: ['Turkey jerky'],
  },
}
